import { render, staticRenderFns } from "./SupermetricsAdmin.vue?vue&type=template&id=25b93172&scoped=true&"
import script from "./SupermetricsAdmin.vue?vue&type=script&lang=js&"
export * from "./SupermetricsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b93172",
  null
  
)

export default component.exports